import { syncHistoryToBrowser, findBasePath } from 'quartz-routing/initialize';
import { createNestedHistory } from 'quartz-routing/createNestedHistory';
import { set } from 'quartz/globalState/api';
import { HISTORY_INSTANCE, HISTORY_BASE_PATH } from 'quartz-routing/globalState';
import { findMostSpecificRoute } from 'quartz-routing/internal/routeMatchingUtils';
import { onPopstateCaptured } from 'quartz-routing/internal/popstate';
import { getCurrentPackageName } from 'quartz/framework/environment/service';
export const _graniteNav = {
  pathname() {
    return window.location.pathname;
  },
  search() {
    return window.location.search;
  },
  href() {
    return window.location.href;
  },
  fullPageNavigate(url) {
    window.location.assign(url);
  }
};
export class HistoryManager {
  constructor() {
    this._activeApp = null;
  }
  get activeApp() {
    return this._activeApp;
  }
  connect(appName, remoteHistory, basename, browserHistory) {
    if (this._activeApp && this._activeApp.history === remoteHistory) {
      return;
    }
    this.disconnect();
    const historyUnlisten = syncHistoryToBrowser(remoteHistory, browserHistory);
    this._activeApp = {
      history: remoteHistory,
      historyUnlisten,
      appName,
      basename
    };
  }
  disconnect() {
    if (this._activeApp) {
      this._activeApp.historyUnlisten();
      this._activeApp = null;
    }
  }
  createAttachHistory(appName, browserHistory) {
    return (remoteHistory, basename) => {
      this.connect(appName, remoteHistory, basename, browserHistory);
    };
  }
  setupPopstateHandling(localRouteOverrides) {
    const handler = () => {
      const newPathname = _graniteNav.pathname();
      const matchedKey = findMostSpecificRoute(Object.keys(localRouteOverrides), newPathname);
      if (!matchedKey) {
        _graniteNav.fullPageNavigate(_graniteNav.href());
        return;
      }
      const newActiveApp = localRouteOverrides[matchedKey].remoteModule || getCurrentPackageName();
      const active = this._activeApp;
      if (active && active.appName === newActiveApp) {
        const relativePath = (_graniteNav.pathname() + (_graniteNav.search() || '')).slice(active.basename.length) || '/';
        active.history.replace(relativePath);
      }
    };
    return onPopstateCaptured(handler);
  }
  createLocalNestedHistory(historyBasename) {
    const basePath = findBasePath(historyBasename, _graniteNav.pathname());
    if (!basePath) {
      throw new Error(`Browser URL does not match historyBasename for the local granite app`);
    }
    const relativePath = _graniteNav.pathname().slice(basePath.basePathname.length) || '/';
    const history = createNestedHistory(basePath.basePathname, relativePath, _graniteNav.search());
    set(HISTORY_INSTANCE, history);
    set(HISTORY_BASE_PATH, basePath);
    return {
      history,
      basename: basePath.basePathname
    };
  }
}